import { Inject, Injectable } from '@angular/core';
import { WebNotificationService, DeviceNotificationService } from '@ridango/components';
import { Capacitor } from '@capacitor/core';
import Env from '@ridango/core/env';

@Injectable({
    providedIn: 'root'
})
export class FirebaseService {
    constructor(
        @Inject('ENV') public env: Env,
        private webNotificationService: WebNotificationService,
        private deviceNotificationService: DeviceNotificationService
    ) {}

    registerFcmSdkToken(): void {
        if (Capacitor.getPlatform() === 'web') {
            this.webNotificationService.initialize();
        } else {
            this.deviceNotificationService.initialize();
        }
    }

    async unsubscribe(): Promise<void> {
        if (Capacitor.getPlatform() === 'web') {
            await this.webNotificationService.unsubscribe();
        }
    }

    checkNotificationSetting(): void {
        if (Capacitor.isNativePlatform()) {
            this.deviceNotificationService.checkNotificationSetting();
        }
    }
}
